export const SET_CONSOLIDATED_EW_LOADING = 'SET_CONSOLIDATED_EW_LOADING';
export const SET_CONSOLIDATED_EW_TABLE_DATA = 'SET_CONSOLIDATED_EW_TABLE_DATA';
export const CLEAR_CONSOLIDATED_EW_STATE = 'CLEAR_CONSOLIDATED_EW_STATE';
